export enum contextMenuAlignment {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER',
  TOP_RIGHT = 'TOP_RIGHT',
  AUTO = 'AUTO'
}
